import React, { useState } from 'react';
import AccountButton from '../_account-button/account-button';
import AccountSelector from '../global/account-selector/account-selector';
import LogoSvg from '../../images/svg/logo';
import './header.scss';
import { OEToggle } from '../global/oe-toggle/oe-toggle';
import { EnablementStatus, MIXPANEL_TRACKING_ENABLED } from '../../constants/common.constants';
import { isProduction } from '../../infrastructure/utils/common.utils';

const Header = () => {
    const [isMixpanelEnabled, setIsMixpanelEnabled] =
        useState(localStorage.getItem(MIXPANEL_TRACKING_ENABLED) === 'true');

    const handleToggleMixpanelTracking = () => {
        localStorage.setItem(MIXPANEL_TRACKING_ENABLED, (!isMixpanelEnabled).toString());
        setIsMixpanelEnabled(prev => !prev);
    };

    return (
        <header className='oe-connect-header'>
            <div className='oe-connect-header__logo'>
                <LogoSvg />
            </div>
            <div className='oe-connect-header__controls'>
                { !isProduction() && <div className='oe-connect-header__mixpanel-toggle'>
                    <OEToggle
                        isSelected={isMixpanelEnabled}
                        onClick={handleToggleMixpanelTracking}
                    />
                    <span className='oe-connect-header__mixpanel-toggle-label'>
                        {`MixPanel is ${isMixpanelEnabled ? EnablementStatus.ENABLED_UPPERCASE : EnablementStatus.DISABLED_UPPERCASE}`}
                    </span>
                </div> }
                <AccountSelector />
                <AccountButton />
            </div>
        </header>
    );
};

export { Header };
